var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B911888F-6C58-4B4F-8A6C-398C96071111") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Working",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment---Discount",
    transform: "translate(-103.000000, -271.000000)",
    fill: "#710D0D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(103.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pricetag",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.535661,0.471424814 C15.2365814,0.168893379 14.8285892,-0.000940877037 14.4031779,3.92094785e-06 L10.0128861,3.92094785e-06 C9.72489412,0.000544821475 9.44873156,0.114627586 9.24432606,0.317500041 L0.467670951,9.09228353 C-0.155890317,9.71711925 -0.155890317,10.7288206 0.467670951,11.3536563 L4.6461802,15.5321246 C5.27118561,16.1559585 6.28328399,16.1559585 6.9082894,15.5321246 L15.6813731,6.76091248 C15.8846518,6.55683648 15.99914,6.28075845 15.9999703,5.99271715 L15.9999703,1.5999684 C16.0025647,1.17679088 15.8353146,0.770248499 15.535661,0.471424814 Z M12.7999762,4.26666954 C12.2108736,4.26666954 11.7333115,3.78910673 11.7333115,3.20000314 C11.7333115,2.61089955 12.2108736,2.13333673 12.7999762,2.13333673 C13.3890788,2.13333673 13.8666409,2.61089955 13.8666409,3.20000314 C13.8666409,3.48290066 13.7542605,3.75421143 13.554222,3.95425019 C13.3541836,4.15428894 13.0828733,4.26666954 12.7999762,4.26666954 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.7551c700f2d8604856d40c62c47dcdde.svg";
export { ForwardRef as ReactComponent };